"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var PropTypes = require('prop-types');

var React = require('react');

var _ = require('lodash');

var compose = require('../../hoc/compose');

var displayNames = require('../displayNames');

var UNITS = require('../../constants/numericInputUnits');

var NumericInput = require('../numericInput');

var Slider = /*#__PURE__*/function (_React$Component) {
  _inherits(Slider, _React$Component);

  var _super = _createSuper(Slider);

  function Slider(props) {
    var _this;

    _classCallCheck(this, Slider);

    _this = _super.call(this, props);

    _this.onSlideStart = function (e) {
      window.addEventListener('mousemove', _this.onSlide, true);
      window.addEventListener('mouseup', _this.onSlideEnd, true);
      _this.boundingClientRect = _this.track.getBoundingClientRect();

      if (_.isFunction(_this.props.onSlideStart)) {
        _this.props.onSlideStart(_this.props.value);
      }

      _this.onSlide(e);
    };

    _this.onSlideEnd = function (e) {
      window.removeEventListener('mousemove', _this.onSlide, true);
      window.removeEventListener('mouseup', _this.onSlideEnd, true);

      _this.onSlide(e);

      if (_.isFunction(_this.props.onSlideEnd)) {
        _this.props.onSlideEnd(_this.props.value);
      }
    };

    _this.onSlide = function (e) {
      if (!_this.props.disabled) {
        var _this$props = _this.props,
            step = _this$props.step,
            min = _this$props.min,
            max = _this$props.max;
        var _this$boundingClientR = _this.boundingClientRect,
            left = _this$boundingClientR.left,
            width = _this$boundingClientR.width;
        var rangeRatio = (e.clientX - left) / width;
        var normalizedRangeRation = Math.min(1, Math.max(0, rangeRatio));
        var newValue = min + (max - min) * normalizedRangeRation;
        var mod = newValue % step;
        var diffToNormalize = mod > step / 2 ? mod - step : mod;
        var newValueStepNormalized = newValue - diffToNormalize;

        _this.handleChange(newValueStepNormalized);
      }
    };

    return _this;
  }

  _createClass(Slider, [{
    key: "getKnobLeftInPercent",
    value: function getKnobLeftInPercent() {
      var knobLeftInPercent = (this.props.value - this.props.min) / (this.props.max - this.props.min) * 100;
      return Math.min(100, Math.max(0, knobLeftInPercent)); // normalize value to be between 0 to 100
    }
  }, {
    key: "getFilledPartWidthInPercent",
    value: function getFilledPartWidthInPercent() {
      if (this.props.value < this.props.min) {
        return 0;
      }

      var fillStart = this.props.fillStart === null ? this.props.min : this.props.fillStart;
      var width = Math.abs(this.props.value - fillStart) / (this.props.max - this.props.min) * 100;
      return Math.min(100, Math.max(0, width));
    }
  }, {
    key: "getFilledPartLeftInPercent",
    value: function getFilledPartLeftInPercent() {
      var fillStart = this.props.fillStart === null ? this.props.min : this.props.fillStart;
      var left = (fillStart - this.props.min) / (this.props.max - this.props.min) * 100;
      return Math.min(100, Math.max(0, left));
    }
  }, {
    key: "getColoredPartStyle",
    value: function getColoredPartStyle() {
      var customGradient = this.props.customFillGradient;
      var gradientColor = this.props.disabled ? '#d5d5d5' : this.props.opacityGradientColor;

      if (gradientColor || customGradient) {
        var fillGradient = this.props.disabled || !customGradient ? "linear-gradient(90deg, transparent 0%, ".concat(gradientColor, " 100%)") : customGradient;
        return {
          background: fillGradient,
          width: '100%'
        };
      }

      var fillStart = this.props.fillStart === null ? this.props.min : this.props.fillStart;
      var flip = this.props.value < fillStart ? 180 : 0;
      return {
        transform: "rotateY(".concat(flip, "deg)"),
        left: this.getFilledPartLeftInPercent() + '%',
        width: this.getFilledPartWidthInPercent() + '%'
      };
    }
  }, {
    key: "hasFillStart",
    value: function hasFillStart() {
      return this.props.fillStart !== null && this.props.fillStart !== this.props.min && this.props.fillStart !== this.props.max;
    }
  }, {
    key: "handleChange",
    value: function handleChange(newValue) {
      if (_.isFunction(this.props.onChange)) {
        this.props.onChange(newValue);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('mousemove', this.onSlide, true);
      window.removeEventListener('mouseup', this.onSlideEnd, true);
    }
  }, {
    key: "onDragStart",
    value: function onDragStart(e) {
      e.preventDefault();
    }
  }, {
    key: "getInputProps",
    value: function getInputProps() {
      return _.defaults({
        step: this.props.inputStep || this.props.step,
        min: _.isNumber(this.props.inputMin) ? this.props.inputMin : this.props.min,
        max: _.isNumber(this.props.inputMax) ? this.props.inputMax : this.props.max
      }, this.props);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        "data-aid": this.props.automationId,
        "data-hook": this.props.dataHook,
        className: this.props.getClassName('control-slider-input') + (this.props.disabled ? ' disabled' : '')
      }, /*#__PURE__*/React.createElement("div", {
        className: 'slider' + ' ' + _({
          'with-numeric-input': !this.props.hideNumericInput
        }).transform(function (res, value, key) {
          if (value) {
            res.push(key);
          }
        }, []).join(' '),
        onDragStart: this.onDragStart
      }, /*#__PURE__*/React.createElement("span", {
        className: "track",
        onMouseDown: this.onSlideStart,
        ref: function (element) {
          this.track = element;
        }.bind(this)
      }, /*#__PURE__*/React.createElement("span", {
        className: 'colored-part' + ' ' + _({
          'has-fill-start': this.hasFillStart()
        }).transform(function (res, value, key) {
          if (value) {
            res.push(key);
          }
        }, []).join(' '),
        style: this.getColoredPartStyle()
      })), /*#__PURE__*/React.createElement("div", {
        className: "knob-container"
      }, /*#__PURE__*/React.createElement("span", {
        className: "knob",
        onMouseDown: this.onSlideStart,
        style: {
          left: this.getKnobLeftInPercent() + '%'
        }
      }))), !this.props.hideNumericInput && /*#__PURE__*/React.createElement(NumericInput, this.getInputProps()));
    }
  }]);

  return Slider;
}(React.Component);

Slider.displayName = displayNames.SLIDER;
Slider.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func,
  opacityGradientColor: PropTypes.string,
  customFillGradient: PropTypes.string,
  hideNumericInput: PropTypes.bool,
  onSlideStart: PropTypes.func,
  onSlideEnd: PropTypes.func,
  onBlur: PropTypes.func,
  disabled: PropTypes.bool,
  inputMin: PropTypes.number,
  inputMax: PropTypes.number,
  min: PropTypes.number,
  max: PropTypes.number,
  unit: PropTypes.oneOf(Object.keys(UNITS)),
  step: PropTypes.number,
  inputStep: PropTypes.number,
  fillStart: PropTypes.number
};
Slider.defaultProps = {
  value: 0,
  step: 1,
  min: 0,
  max: 100,
  fillStart: null
};
module.exports = compose(Slider);